/**
 * @file: SafeTrain.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 安全培训
 */
import request from '@/utils/request'

/**
 * 新增/修改（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function safetrainCreate(data) {
  return request({
    type: 'biz',
    url: 'safetrain/create',
    method: 'post',
    data
  })
}

/**
 * 获取详情信息（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function safetrainGet(data) {
  return request({
    type: 'biz',
    url: 'safetrain/get',
    method: 'post',
    data
  })
}

/**
 * 获取分页信息（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function safetrainPageList(data) {
  return request({
    type: 'biz',
    url: 'safetrain/page/list',
    method: 'post',
    data
  })
}

/**
 * 修改状态（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function safetrainUpdateStatus(data) {
  return request({
    type: 'biz',
    url: 'safetrain/update/status',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/SafeTrain.js